import { render, staticRenderFns } from "./DialogRouter.vue?vue&type=template&id=20a1b010"
import script from "./DialogRouter.vue?vue&type=script&lang=js"
export * from "./DialogRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports